import type {MoleculeIllustration} from './molecule-model';
import {MoleculeActivity} from './MoleculeActivity';
import {MoleculeReferenceFields} from './MoleculeReferenceFields';
import {MathText} from './MathText';

/** Observation media: no answer, controls, progress or validation to complete. */
export function DocumentMolecules({items}:{items?:MoleculeIllustration[]}){
 return items?.length?<div className="document-molecules">{items.map((item,i)=><figure key={i}>
  <MoleculeActivity reference={item.molecule} interactive={false}/>
  {item.caption&&<figcaption><MathText text={item.caption}/></figcaption>}
 </figure>)}</div>:null;
}
export function DocumentMoleculesEditor({items=[],onChange,correction=false}:{items?:MoleculeIllustration[];onChange:(items:MoleculeIllustration[])=>void;correction?:boolean}){
 return <details><summary>{correction?'Illustrations de la correction (après restitution)':'Illustrations moléculaires du document'}</summary>
  <p>{correction?'Ces médias sont réservés au professeur et aux copies restituées.':'Illustrations à observer : aucune réponse ni manipulation obligatoire.'}</p>
  {items.map((item,i)=><fieldset key={i}><legend>Illustration {i+1}</legend>
   <MoleculeReferenceFields allowLearnerChoices={false} value={item.molecule} onChange={molecule=>onChange(items.map((x,j)=>i===j?{...x,molecule}:x))}/>
   <label>Légende<input value={item.caption??''} onChange={e=>onChange(items.map((x,j)=>i===j?{...x,caption:e.target.value}:x))}/></label>
   <button type="button" onClick={()=>onChange(items.filter((_,j)=>i!==j))}>Retirer cette illustration</button>
  </fieldset>)}
  <button type="button" disabled={items.length>=6} onClick={()=>onChange([...items,{molecule:{moleculeId:'water',view:correction?'lewis':'ball-stick'}}])}>Ajouter une illustration moléculaire</button>
 </details>;
}
